import { Component, OnInit, Input } from '@angular/core';

import { AreaDrawerService } from '@commons/services/map/drawer/area/area-drawer.service';
import { Area } from '../../../../commons/models/domain/Area';

@Component({
    selector: 'tk-area-list-item',
    styleUrls: ['./area-list-item.component.less'],
    templateUrl: './area-list-item.component.html'
})
export class AreaListItemComponent {

    /**
     * Area to show
     */
    @Input() public area!: Area;

    @Input() isSelected: boolean = false;

    /**
     * Component constructor
     * @param $areaDrawer area drawer service
     */
    constructor(
        private $areaService: AreaDrawerService
    ) { }


    public editArea() {
        setTimeout(() =>
            this.$areaService.selectedAreaSubject.next(this.area), 300);
    }
}
